// ==========================================================================
// GUIDE - pages guides du kit 2026 (guide/guide.aspx)
//
// 1. --mfp-sticky-top : hauteur reelle du header quand il est collant (elle varie
//    avec le bandeau promo et n'est collante que sur mobile), plus 16px. Les
//    sections ancrees s'en servent pour leur scroll-margin-top.
// 2. Sommaire B02 : section courante (aria-current), la liste suit l'entree
//    active dans son cadre defilant, repli / depli en mobile.
// 3. Barre CTA collante S06 : revelee une fois le hero passe au-dessus de
//    l'ecran, retiree quand le pied de page entre dans l'ecran. L'etat est porte
//    par data-on, jamais par display (scroll anchoring).
// ==========================================================================
(function () {
    'use strict';

    var MOBILE = 1100;

    // --- 1. Hauteur de la bande fixee en haut de l'ecran --------------------
    // Header collant s'il l'est, et bandeau promo fixe (#promoope, affiche par
    // promo.js apres le chargement, fermable) : les deux partent du bord haut, on
    // garde le plus haut. Recalculee au defilement, le bandeau pouvant apparaitre
    // ou disparaitre apres coup.
    function hauteurHeader() {
        var h = 0;
        var header = document.querySelector('.site-header');
        if (header) {
            var position = window.getComputedStyle(header).position;
            if (position === 'sticky' || position === 'fixed') h = header.offsetHeight;
        }
        var promo = document.getElementById('promoope');
        if (promo) {
            var style = window.getComputedStyle(promo);
            if (style.display !== 'none' && style.position === 'fixed') h = Math.max(h, promo.offsetHeight);
        }
        return h;
    }

    var stickyTopPose = '';
    function poserStickyTop() {
        var h = hauteurHeader();
        var valeur = (h ? h + 16 : 24) + 'px';
        if (valeur === stickyTopPose) return;
        stickyTopPose = valeur;
        document.documentElement.style.setProperty('--mfp-sticky-top', valeur);
    }

    // --- 2. Sommaire -------------------------------------------------------
    var toc = document.querySelector('[data-mfp-toc]');
    var tocLiens = toc ? Array.prototype.slice.call(toc.querySelectorAll('a[href^="#"]')) : [];
    var tocBox = toc ? toc.closest('.mfp-side__scroll') : null;

    function suivreSommaire(box, actif) {
        // Jamais scrollIntoView, qui deplacerait aussi la page : on pilote le
        // scrollTop du seul conteneur defilant
        if (!box || !actif || box.scrollHeight <= box.clientHeight) return;
        var top = actif.offsetTop - box.offsetTop;
        var marge = 48;
        var cible = box.scrollTop;
        if (top < box.scrollTop + marge) cible = Math.max(0, top - marge);
        else if (top + actif.offsetHeight > box.scrollTop + box.clientHeight - marge) cible = top + actif.offsetHeight - box.clientHeight + marge;
        if (Math.abs(cible - box.scrollTop) > 1) box.scrollTo({ top: cible, behavior: 'smooth' });
    }

    function majSommaire() {
        if (!tocLiens.length) return;
        var seuil = hauteurHeader() + 60;
        var actif = null;
        tocLiens.forEach(function (a) {
            var cible = document.getElementById(a.getAttribute('href').slice(1));
            if (cible && cible.getBoundingClientRect().top <= seuil) actif = a;
        });
        tocLiens.forEach(function (a) {
            if (a === actif) a.setAttribute('aria-current', 'true');
            else a.removeAttribute('aria-current');
        });
        if (window.innerWidth > MOBILE) suivreSommaire(tocBox, actif);
    }

    if (toc) {
        var tete = toc.querySelector('.mfp-toc__head');
        if (tete) {
            tete.addEventListener('click', function () {
                if (window.innerWidth <= MOBILE) toc.classList.toggle('is-open');
            });
        }
        // clic sur une entree : defilement anime jusqu'a la section (scroll-margin-top respecte),
        // ancre posee dans l'URL sans saut ; en mobile le sommaire se replie
        var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        tocLiens.forEach(function (a) {
            a.addEventListener('click', function (e) {
                var cible = document.getElementById(a.getAttribute('href').slice(1));
                if (cible) {
                    e.preventDefault();
                    cible.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'start' });
                    if (window.history && history.pushState) history.pushState(null, '', a.getAttribute('href'));
                }
                if (window.innerWidth <= MOBILE) toc.classList.remove('is-open');
            });
        });
    }

    // --- 3. Barre CTA collante ---------------------------------------------
    var barre = document.querySelector('[data-mfp-stickybar]');
    var etatBarre = { heroPasse: false, piedVisible: false };

    function majBarre() {
        if (!barre) return;
        var mobile = window.innerWidth <= MOBILE;
        barre.setAttribute('data-on', (mobile && etatBarre.heroPasse && !etatBarre.piedVisible) ? '1' : '0');
    }

    if (barre && window.IntersectionObserver) {
        var hero = document.querySelector('.mfp-hero') || document.querySelector('.mfp-guide__layout');
        var pied = document.querySelector('footer');
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
                if (e.target === hero) etatBarre.heroPasse = !e.isIntersecting && e.boundingClientRect.top < 0;
                if (e.target === pied) etatBarre.piedVisible = e.isIntersecting;
            });
            majBarre();
        }, { threshold: 0 });
        if (hero) io.observe(hero);
        if (pied) io.observe(pied);
    }

    // --- 4. Texte replie « Lire plus » (B28, B07) ---------------------------
    // Un seul ecouteur delegue ; l'etat vit sur data-open et aria-expanded, pilotes
    // ensemble pour que le repli soit annonce aux lecteurs d'ecran
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.mfp-more__btn');
        if (!btn) return;
        var rest = document.getElementById(btn.getAttribute('aria-controls'));
        if (!rest) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (open) rest.removeAttribute('data-open'); else rest.setAttribute('data-open', '');
        var label = btn.querySelector('.mfp-more__label');
        if (label) label.textContent = open ? (btn.getAttribute('data-plus') || 'Lire plus') : (btn.getAttribute('data-moins') || 'Lire moins');
    });

    // --- 5. Bouton de copie (B19 modeles de textes, B06 tableau a recopier) ----
    // Une cible <table> est copiee en TSV : collee dans un tableur, elle se
    // repartit en cellules au lieu d'arriver en un seul bloc
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.mfp-copy');
        if (!btn) return;
        var src = document.querySelector(btn.getAttribute('data-copy'));
        if (!src) return;
        var tip = btn.querySelector('.mfp-copy__tip');
        var texte;
        if (src.tagName === 'TABLE') {
            texte = Array.prototype.map.call(src.rows, function (row) {
                return Array.prototype.map.call(row.cells, function (c) { return c.textContent.replace(/\s+/g, ' ').trim(); }).join('\t');
            }).join('\n');
        } else {
            texte = src.textContent.trim();
        }
        function fini(ok) {
            if (!tip) return;
            var ancien = tip.textContent;
            tip.textContent = ok ? 'Copié' : 'Sélectionné, faites Ctrl+C';
            btn.setAttribute('data-done', '1');
            setTimeout(function () { tip.textContent = ancien; btn.removeAttribute('data-done'); }, 2200);
        }
        function selectionner() {
            try {
                var r = document.createRange();
                r.selectNodeContents(src);
                var s = window.getSelection();
                s.removeAllRanges();
                s.addRange(r);
            } catch (err) { }
            fini(false);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(texte).then(function () { fini(true); }, selectionner);
        else selectionner();
    });

    // --- 6. Video en lecture differee (B26) : l'iframe n'est inseree qu'au clic ---
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.mfp-video__frame');
        if (!btn) return;
        var id = btn.getAttribute('data-yt');
        if (!id) return;
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
        iframe.title = btn.getAttribute('aria-label') || 'Vidéo';
        iframe.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        btn.replaceWith(iframe);
    });

    // --- 7. Outils (B31) : prompt copie pour Gemini, copie du lien de la page ---
    document.addEventListener('click', function (e) {
        var g = e.target.closest('[data-copy-prompt]');
        if (g && navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(g.getAttribute('data-copy-prompt')).catch(function () { });
        }
        var b = e.target.closest('.mfp-tools__copy');
        if (!b) return;
        var url = b.getAttribute('data-copy-url');
        var tip = b.querySelector('.mfp-tools__tip');
        function fini() {
            b.setAttribute('data-done', '');
            if (tip) tip.textContent = 'Lien copié';
            setTimeout(function () { b.removeAttribute('data-done'); if (tip) tip.textContent = 'Copier le lien'; }, 2200);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(fini, function () { window.prompt('Copiez le lien :', url); });
        else window.prompt('Copiez le lien :', url);
    });

    // --- 8. Onglets de la collection univers (U06) : aria-selected et panel actif -----
    document.addEventListener('click', function (e) {
        var tab = e.target.closest('.mfp-tabs__tab');
        if (!tab) return;
        var tabs = tab.closest('.mfp-tabs');
        var section = tabs.parentNode;
        Array.prototype.forEach.call(tabs.querySelectorAll('.mfp-tabs__tab'), function (t) {
            var actif = t === tab;
            t.setAttribute('aria-selected', String(actif));
            var panel = section.querySelector('#' + t.getAttribute('aria-controls'));
            if (!panel) return;
            if (actif) panel.setAttribute('data-active', ''); else panel.removeAttribute('data-active');
        });
    });

    // --- Evenements --------------------------------------------------------
    function tout() {
        poserStickyTop();
        majSommaire();
        majBarre();
    }

    window.addEventListener('scroll', function () { poserStickyTop(); majSommaire(); }, { passive: true });
    window.addEventListener('resize', tout);
    window.addEventListener('load', tout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(tout);
    tout();
})();
